import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatePickerYears',
  props: {
  fromYear: {
    type: Number,
    required: true,
  },
  toYear: {
    type: Number,
    required: true,
  },
  selectedDate: {
    type: Date,
    required: true
  }
},
  emits: ['select-date'],
  setup(__props, { emit }) {

const props = __props;





const years = computed(() => Array.from(Array(props.toYear - props.fromYear + 1).keys()).map((year) => year + props.fromYear));

const selectedYear = computed(() => props.selectedDate.getFullYear());

const onSelectYear = (year: number) => {
  const date = new Date(props.selectedDate);
  date.setYear(year);
  emit('select-date', date);
};


return { __sfc: true,props, emit, years, selectedYear, onSelectYear }
}

})